import React, { useState } from "react";
import { Grid2 as Grid, Accordion, AccordionSummary, AccordionDetails } from '@mui/material';
import { PersonAdd, ExpandMore } from '@mui/icons-material';
import { BoxSpaceCenter } from "../style/box";
import { RegisterButton } from "../style/button";
import { TypographyBold } from '../style/typography';
import { CustomControlledInput } from "./CustomControlledInput";

const WorkRegistration = ({ control, workCategories, openDialog, handleRegistSubmit, expanded = false, isDisabled }) => {
    const [isExpanded, setIsExpanded] = useState(expanded);

    return (
        <Grid size={{ xs: 12 }}>
            <Accordion expanded={isExpanded} onChange={() => setIsExpanded(!isExpanded)}>
                <AccordionSummary
                    expandIcon={<ExpandMore />}
                    aria-controls="work-registration-content"
                    id="work-registration-header"
                >
                    <TypographyBold>新規業務登録</TypographyBold>
                </AccordionSummary>
                <AccordionDetails>
                    <Grid container spacing={3}>
                        {/* 業務名 */}
                        <Grid size={{ xs: 12, md: 6 }}>
                            <CustomControlledInput
                                name="registWork.name"
                                control={control}
                                label="業務名"
                                variant="outlined"
                                placeholder="情報収集"
                                inputProps={{ maxLength: 100 }}
                                disabled={isDisabled}
                            />
                        </Grid>
                        {/* 業務カテゴリ */}
                        <Grid size={{ xs: 12, md: 6 }}>
                            <CustomControlledInput
                                name="registWork.category"
                                control={control}
                                label="業務カテゴリ"
                                type="select"
                                multiple={false}
                                options={workCategories.map((c) => ({
                                    value: c.value,
                                    label: c.label
                                }))}
                                disabled={isDisabled}
                            />
                        </Grid>
                        {/* 登録ボタン */}
                        <Grid container size={{ xs: 12 }} justifyContent="center">
                            <Grid size={{ xs: 12, md: 6 }}>
                                <BoxSpaceCenter>
                                    <form
                                        style={{ width: "100%" }}
                                        onSubmit={handleRegistSubmit((data) => { openDialog('register', data.registWork); })}
                                    >
                                        <RegisterButton
                                            fullWidth
                                            type="submit"
                                            variant="contained"
                                            startIcon={<PersonAdd />}
                                            disabled={isDisabled}
                                        >
                                            業務名を登録
                                        </RegisterButton>
                                    </form>
                                </BoxSpaceCenter>
                            </Grid>
                        </Grid>
                    </Grid>
                </AccordionDetails>
            </Accordion>
        </Grid>
    );
};

export default WorkRegistration;